import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import OrnamentReviewStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import { useSelector } from "react-redux";
import RateOfInterest from "../pages/FieldAgent/RateOfInterest";
import { textFormat } from "utils/Utils";
import { Grid } from "@material-ui/core";
import ToastModal from "views/components/ToastModal";
import { toCamelCase } from "utils/Utils";
import { formatAmount } from "utils/Utils";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
const useStyles = makeStyles(OrnamentReviewStyle);

const OrnamentReview = ({ loanApplicationId,classes }) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [record, setRecord] = useState({});
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
      GetLoanOrnamentDetails();
  },[])
  const GetLoanOrnamentDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        setRecord(result?.data);
      }
    };
 function renderObject(object){
  return Object?.entries(object)?.map(([key, value], i) => {
    return (
      <GridContainer key={key} style={{ display: 'flex', flexWrap: 'nowrap' }}>
         <GridItem xs={12} sm={12} md={12} lg={12}>
             <p style={{ margin: '2px'}}> {key}</p>        
             </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
          <p style={{ margin: '2px'}}>{value}</p>             
           </GridItem>       
      </GridContainer>
    )
  })
}
  const itemView = (label, value) => {
    return (
      <Grid item xs={5} sm={6} md={4} className={classes.fieldContaienrReview}>
            <p style={{ marginBottom: 0 }}>
              <b>{toCamelCase(label)}</b>
            </p>
            <label>{value}</label>
       </Grid>
    );
  };
  return (
    <div>
            <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header}  style={{fontSize:"1.5rem"}}>Loan Details</h2>
      </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
            {itemView("ORNAMENT VALUE", formatAmount(record.eligibleLoanAmt) || "NA")}
            {itemView("ACTUAL LOAN AMOUNT", formatAmount(record.actualLoanAmount) || "NA")}
            {itemView("LOAN SCHEME CHANNEL", textFormat(record.loanSchemeChannel) || "NA")}
            {itemView("LOAN SCHEME", textFormat(record.loanSchemeName) || "NA")}
            {itemView("LTV", record.ltv || "NA")}
            {/* {itemView(
              "PROCESSING FEE (Inclusive of GST)",
              record.processingFee || "NA"
            )} */}
            {itemView("MONTHLY INTEREST",  formatAmount(Math.round(record.monthlyInterest)) || "NA")}

            {itemView("TENURE", record.tenureInMonths || "NA")}
            {itemView("TARE WEIGHT", record.tareWeight || "NA")}
            {record?.revisedLoanAmt && itemView("REVISED LOAN AMOUNT", formatAmount(record.revisedLoanAmt) || "NA")}
            {record?.revisedAnnualRoi && itemView("REVISED ANNUAL ROI", record.revisedAnnualRoi || "NA")}
          </Grid></Grid>
          <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header}  style={{fontSize:"1.5rem"}}>Rate Of Interest</h2>
      </Grid>
            <RateOfInterest ornamentObj={record} classes={classes}/>
          <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputFieldContainer}
      >
        <h2 className={classes.header}  style={{fontSize:"1.5rem"}}>Ornament List</h2>
      </Grid>
          {record?.ornamentDetails &&
            record?.ornamentDetails?.map((ornament, index) => (
              <>
                <GridContainer key={index}>
                  {itemView("FINESSE CODE", ornament.finnesseCode)}
                  {itemView("GROSS WEIGHT", ornament.grossWeight)}
                  {itemView("STONE WEIGHT", ornament.stoneWeight)}
                  {itemView("DEDUCTION", ornament.deduction)}
                  {itemView("NET WEIGHT", ornament.netWeight)}
                  {itemView("22K Equivalent Net Weight", ornament.netWeightWith22k)}
                  {itemView("Ornament Name", textFormat(ornament.particulars))}
                  {itemView("SOURCE OF OWNERSHIP", textFormat(ornament.sourceOfOwnership))}
                  {itemView("PACKET NUMBER", ornament.packetNumber)}
                  {itemView("PACKET SEAL NUMBER", ornament.packetSealNumber)}
                  {itemView("COUNT", ornament.itemCount)}
                  {itemView("Remarks", textFormat(record.remarks))}
                </GridContainer>
                <hr />
              </>
            ))}
          {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
    </div>
  );
};

OrnamentReview.propTypes = {
  classes: PropTypes.object,
  loanApplicationId: PropTypes.object,
};

export default OrnamentReview;
